export default () => {
  return {
    title: 'Forgot Your Password?',
    subTitle:
      'We will send you a link to reset your password.',
    emailLabel: 'Email',
    button: 'Send Email',
    link: 'Return to Sign In',
  };
};
